export default {
    tw: {
        LP: {
            nav: [{
                    name: "TOP",
                    id: "nav-top"
                },
                {
                    name: "藝術家的訊息",
                    id: "nav-message"
                },
                {
                    name: "體驗",
                    id: "nav-expenrise"
                },
                {
                    name: "藝術家介紹",
                    id: "nav-artist"
                },
                {
                    name: "蒲公英的種植地",
                    id: "nav-place"
                },
                {
                    name: "大家制作的DANDELION",
                    id: "nav-result"
                },
                // {
                //     name: "植樹支援のお願い",
                //     id: "nav-contribution"
                // },
                {
                    name: "支援者",
                    id: "nav-supporters"
                },
                {
                    name: "諮詢",
                    id: "nav-supporters"
                },
            ],
            top_desc_mb: "「DANDELION」是連接世界的藝術作品。\n\n對著蒲公英吹氣，\n被吹起的絨毛滿天飛舞，\n飛舞著飄越國界。\n飄落到世界各地，在全球各個地區設置的「DANDELION」作品旁開出許願的花朵。\n\n全世界收集到的花朵，將會彙聚成美麗的花海。\n\n“希望世界和平”\n“希望世界變得更加美好”\n讓你的願望，隨著你的絨毛一起，\n在全世界開花吧！",
            top_desc_pc: "「DANDELION」是連接世界的藝術作品。\n\n對著蒲公英吹氣，\n被吹起的絨毛滿天飛舞，飛舞著飄越國界。\n飄落到世界各地，在全球各個地區設置的「DANDELION」作品旁開出許願的花朵。\n全世界收集到的花朵，將會彙聚成美麗的花海。\n\n“希望世界和平”\n“希望世界變得更加美好”\n讓你的願望，隨著你的絨毛一起，在全世界開花吧！",
            msg: {
                msg_title: "藝術家的訊息",
                msg_desc_mb: "2020年以來，整個世界都迎來了各種各樣的變化，在這變化之中，我們開始思考要如何與這個世界，與他人進行連結。\n\n在這個誰都擁有話語權，和任何人都可以隨時進行溝通的時代。\n言語主義主張“一個正確性”來傾訴感情，但是這並不能概括全部。 我們依然相信，可以通過一個和平，平穩的願望，在溫和的情感中拉近人與人的距離，連結人與人的心。\n\n「DANDELION」就是這樣一個以簡單形式連結世界各地所有人的作品。\n\n向蒲公英禱告許願吹氣, 這個簡單的體驗,無論是誰在小時候都做過的原始行為，並且帶著所有人的願景讓世界各地都開滿花來, 我個人非常喜歡這個作品。\n鮮花不需要語言，也不會因分隔兩地而有不同認知。種子飛翔，無論到達哪里都會再次開花。通過這種方式，我們希望每個人，不分國家、種族或意識形態，都能通過藝術聯系起來，讓鮮花開遍全世界。",

                msg_desc_pc: "2020年以來，整個世界都迎來了各種各樣的變化，在這變化之中，我們開始思考要如何與這個世界，與他人進行連結。\n\n在這個誰都擁有話語權，和任何人都可以隨時進行溝通的時代。\n言語主義主張“一個正確性”來傾訴感情，但是這並不能概括全部。 我們依然相信，可以通過一個和平，平穩的願望，在溫和的情感中拉近人與人的距離，連結人與人的心。\n\n「DANDELION」就是這樣一個以簡單形式連結世界各地所有人的作品。\n\n向蒲公英禱告許願吹氣, 這個簡單的體驗,無論是誰在小時候都做過的原始行為，並且帶著所有人的願景讓世界各地都開滿花來, 我個人非常喜歡這個作品。\n鮮花不需要語言，也不會因分隔兩地而有不同認知。種子飛翔，無論到達哪里都會再次開花。通過這種方式，我們希望每個人，不分國家、種族或意識形態，都能通過藝術聯系起來，讓鮮花開遍全世界。",
                msg_foot: "村松亮太郎 / NAKED"
            },
            art: {
                title1: "藝術家介紹",
                title2: "村松亮太郎 / NAKED",
                title3: "藝術家",
                desc1: "NAKED,INC的代表。 1997年創立了創意型公司NAKED,INC以來，在影視、電視劇、MV、廣告、空間創意、地方創生、教育計劃種種領域中都十分活躍。",
                desc2: "NAKED,INC的代表。 1997年創立了創意型公司NAKED,INC以來，在影視、電視劇、MV、廣告、空間創意、地方創生、教育計劃種種領域中都十分活躍。他導演的長篇/短片電影作品，在國際電影節上獲得了48項提名，並獲得多個獎項。 近幾年更是親自策劃了「FLOWERS BY NAKED」「TOKYO ART CITY BY NAKED」「TREE by NAKED」等等，沉浸式展覽，餐廳，並把華道・茶道・香道・歌舞伎・能狂言這樣的日本傳統文化・技藝，和先進的表現手法相結合，打造出全新藝術演出。 在大阪藝術大學擔任特約教授的同時，作為總創意人以長野縣・阿智村為中心，參與了大阪府・堺市，佐賀縣等等日本各地的地方重造計劃以及擔當文化推廣大使。從2018年開始以個人藝術家的身份進行創作，並在國內外展出了自己的作品。 2019年，參與了在義大利・威尼斯，由輕井澤新藝術美術館主辦的「DIVERSITY FOR PEACE！」，參與了在中國・蘇州舉辦的「SUZHOU DESIGN WEEK」。 並且在香港的HQUSSENS的白石畫廊首次開展個人藝術展「002」、在佳士得舉辦的「Christie‘s Autumn Auctions Hong Kong 2019」上，策劃並製作了沉浸式招待晚宴。 2020年在這個被疫情隔斷的世界，著手策劃了祈願和平，以全新的形式連結世界的藝術作品『DANDELION PROJECT』 ，並且這件作品在正在向世界範圍內擴大展出中。",
            },
            experrience: {
                text_title1: '大家一起來體驗',
                text_title2_mb: "讓只屬於你的蒲公英\n飄向全世界",
                text_title2_pc: "讓只屬於你的蒲公英飄向全世界",
                text_btn: '體驗\n「DANDELION」',
                text_link: '支援此活動',
                text_desc: "因為有你的支援\n「DANDELION」才能在全世界展開植樹活動",
            },
            result: {
                text_title1_mb: "大家一起製作的\nDANDELION",
                text_title1_pc: "大家一起製作的\nDANDELION",
                text_title2: "FRIENDS OF\nDANDELION PROJECT",
                text_desc: "在這裡收集了大家體驗後的絨毛，\n並創造出全新的DANDELION",
                names: [{
                    firstName: "佐野光咲",
                    lastName: ""
                }, {
                    firstName: "佐野正騎",
                    lastName: ""
                }, {
                    firstName: "NOBU. MARUYAMA",
                    lastName: ""
                }, {
                    firstName: "JUN TERAYAMA",
                    lastName: ""
                }, {
                    firstName: "Ryuta Shimba",
                    lastName: ""
                }, {
                    firstName: "Shinsaku Nakagawa",
                    lastName: ""
                }, {
                    firstName: "Reiji Higashimaki",
                    lastName: ""
                }, {
                    firstName: "Erina",
                    lastName: ""
                }, {
                    firstName: "衞藤登喜子",
                    lastName: ""
                }, {
                    firstName: "深田しのぶ",
                    lastName: ""
                }, {
                    firstName: "小林優人",
                    lastName: ""
                }, {
                    firstName: "松田英樹",
                    lastName: ""
                }, {
                    firstName: "衞藤正和",
                    lastName: ""
                }, {
                    firstName: "衞藤弥保",
                    lastName: ""
                }]
            },
            placeText: {
                title: "蒲公英的種植地",
                desc_mb: "「DANDELION蒲公英」正在世界各地種植中",
                desc_pc: "「DANDELION蒲公英」正在世界各地種植中"
            },
            ctr: {
                title1: "支援此藝術作品",
                title2: "",
                desc1_mb: "『DANDELION PROJECT』是象徵著世界和平、祈願和平的作品，\n你的支援可以讓「DANDELION」的種植計劃到達更多地方。",
                desc1_pc: "『DANDELION PROJECT』是象徵著世界和平、祈願和平的作品，\n你的支援可以讓「DANDELION」的種植計劃到達更多地方。",
                desc2: "請從以下選擇支持金額，然後單擊“支援此活”按鈕。",
                btn1: "支援此活動",
                btn2: "",
                input_tips: "請隨意輸入金額。",
                price_type: "USD$",
                safari_tips1: "※如果您使用的是 Safari，請參閱",
                safari_tips2: "此處的說明",
                safari_tips3: "。",
                safari_setting_tips: "如果您使用的是 Safari，請檢查以下設置。\n設置> Safari> 彈出框> 關閉\n 請設置。",
                min_money_tips: "※您可以從 0.5 美元進入。",
                law_tips: 'Specified Commercial Transaction Act',
                pay_urls: [{
                        name: "JP¥100",
                        url: "https://buy.stripe.com/4gw16J9ea1vN2IMdQS"
                    },
                    {
                        name: "JP¥500",
                        url: "https://buy.stripe.com/eVa02Fbmi5M31EI9AD"
                    }, {
                        name: "JP¥1,000",
                        url: "https://buy.stripe.com/00g02Fcqm1vNfvy7sw"
                    },
                    {
                        name: "JP¥10,000",
                        url: "https://buy.stripe.com/eVabLnfCy6Q7fvy7sx"
                    }
                ]

            },
            supportTitle: "SUPPORTERS",
            contactTitle: "CONTACT US",
            // OGP用情報
            ogp: {
                title: 'DANDELION PROJECT',
                description: '平和への祈りを、アートで繋ぐ。',
                type: 'website',
                url: 'www.breathbless.com',
                site_name: 'DANDELION PROJECT Official Site',
                image: '/Images/Ogp/OGP_breath.jpg',
                twitter_card: 'summary_large_image'
            },

            // タイトル
            title: 'Uniting Prayers for Peace',
            title_sp: 'Uniting' +
                '\r\n' +
                'Prayers' +
                '\r\n' +
                'for' +
                '\r\n' +
                'Peace',

            // サブタイトル
            subtitle: '平和への祈りを、アートで繋ぐ。',

            // ページの詳細
            description: 'これは、世界のあらゆる地点を結びながら、人々が参加することで成長するアート作品。\r\n' +
                '\r\n' +
                'たんぽぽの綿毛を飛ばすように、「Dandelion」に息を吹きかけると、\r\n' +
                'その綿毛は遠く離れた街へと舞い移り美しい花を咲かせます。\r\n' +
                '\r\n' +
                'さまざまな街から発せられる「Breath（吐息）」が、平和を願う「Bless（祈り）」の種となって世界へ。\r\n' +
                '\r\n' +
                'リアルとバーチャルがシンクロし、\r\n' +
                'ネットワークそのものが国境を越えるアートとして成長し続けます。',
            description_sp: 'これは、世界のあらゆる地点を結びながら、\r\n' +
                '人々が参加することで成長するアート作品。\r\n' +
                '\r\n' +
                'たんぽぽの綿毛を飛ばすように、「Dandelion」に息を吹きかけると、\r\n' +
                'その綿毛は遠く離れた街へと舞い移り美しい花を咲かせます。\r\n' +
                '\r\n' +
                'さまざまな街から発せられる「Breath（吐息）」が、\r\n' +
                '平和を願う「Bless（祈り）」の種となって世界へ。\r\n' +
                '\r\n' +
                'リアルとバーチャルがシンクロし、\r\n' +
                'ネットワークそのものが国境を越えるアートとして\r\n' +
                '成長し続けます。',

            // Send a Prayerボタンの接続先
            send_url: 'https://naked.co.jp/works/',

            title2: 'SEND A PRAYER',
            title2sp: 'SEND' +
                '\r\n' +
                'A' +
                '\r\n' +
                'PRAYER',
            subtitle2: 'あなたの平和への祈りで世界に花を咲かせましょう。',

            textcontents_qr: '今、『Dandelion』の近くにいる方',
            textcontents_qr_button: 'インタラクティブマーカー',

            textcontents_ol: 'オンラインから作品に参加される方',
            textcontents_ol_button: 'あなたの花を見つける',

            // Send a Prayerボタンから出るモーダルに表示される画像
            // send_modal_image: './Images/LP_dande_contents_0822.jpg',
            // send_modal_image_sp: './Images/LP_dande_SP-contents_0824.jpg',
            // send_modal_image_tb: './Images/LP_dande_ipad_0825.jpg',

            send_modal_image: './Images/maker_jp.jpg',
            // send_modal_image_sp: './Images/maker.jpg',
            // send_modal_image_tb: './Images/maker.jpg',

            // 会社ロゴ
            corporate_logo: './Images/NAKED,INC._Logotype_b.png',

            // 会社ロゴからの接続先
            corporate_url: 'https://naked.co.jp',

            // お問い合わせの接続先
            contact_url: 'https://naked.co.jp/contact/',

            // メッセージ
            //
            // thumbnail => サムネイル画像
            // title => タイトル
            // description => 詳細説明
            message: {
                thumbnail: './Images/RM.jpg',
                title: 'ARTIST',
                name: 'Ryotaro Muramatsu / NAKED ',
                description: 'アーティスト。NAKED, INC.代表。大阪芸術大学客員教授。長野県・阿智村ブランディングディレクター。 1997年にクリエイティブカンパニーNAKED, INC.を設立以来、映画やテレビ、MV、広告、空間演出など、ジャンルを超えてさまざまなプロジェクトを率いてきた。監督作品は長編/短編合わせて国際映画祭で48ノミネート&受賞。近年では「FLOWERS BY NAKED」「TOKYO ART CITY BY NAKED」などのイマーシブ(没入型)イベントや、華道・茶道・香道・歌舞伎・能狂言といった伝統文化・芸能と先進の表現を掛け合わせたインスタレーションや公演を手がける。大阪芸術大学で客員教授を務めるほか、ブランディング・ディレクターを務める長野県・阿智村をはじめ大阪府・堺市や佐賀県など日本各地での地方創生イベントや文化プロジェクトに取り組む。2018年には個人アーティストとしての創作活動を開始し、国内外で作品を発表してきた。',
                message: '2020年、この世界はさまざまな意味で大きく変わりました。' +
                    '\r\n' +
                    '不安の多い時期は続きそうですが、この経験が世界を分断するのではなく、むしろ新しいかたちで僕たちを結びつけるきっかけになって欲しいと感じています。' +
                    '\r\n' +
                    '\r\n' +
                    '人それぞれ異なるバックグラウンドを持っていますが、より良い世界になってほしいという思いは皆同じなのではないでしょうか。主義主張によって"一つの正しさ"を追求しようとすると終わりがありませんが、平和や平穏への祈りといった優しい感情を通して繋がり合う方法もあると信じたいです。' +
                    '\r\n' +
                    '\r\n' +
                    '「Dandelion」は、タンポポに息を吹きかけると舞い上がった綿毛が地面に根付き、新しい花を咲かせるインタラクティブ作品です。デジタルによって表現が拡張されるアートなのですが、タンポポに祈りを込めて吹くという、誰もが子供の頃に遊んだピュアな原体験的感覚を呼び起こすこの作品を、僕自身とても気に入っています。' +
                    '\r\n' +
                    '\r\n' +
                    '花は言葉を必要とせず、物事を分け隔てることもしません。' +
                    '\r\n' +
                    '種子を飛ばし、たどり着いた先でまた花を咲かせます。' +
                    '\r\n' +
                    'そんな風に、国や人種、思想に関わらず誰もが知っているシンプルな行為がアートとなって人々の祈りを繋げ、世界中に花を咲かせることができればと願っています。' +
                    '\r\n' +
                    '\r\n' +
                    '村松 亮太郎',
                message_sp: '『2020年、この世界はさまざまな意味で大きく変わりました。不安の多い時期は続きそうですが、この経験が世界を分断するのではなく、むしろ新しいかたちで僕たちを結びつけるきっかけになって欲しいと感じています。' +
                    '\r\n' +
                    '\r\n' +
                    '人それぞれ異なるバックグラウンドを持っていますが、より良い世界になってほしいという思いは皆同じなのではないでしょうか。主義主張によって"一つの正しさ"を追求しようとすると終わりがありませんが、平和や平穏への祈りといった優しい感情を通して繋がり合う方法もあると信じたいです。' +
                    '\r\n' +
                    '\r\n' +
                    '「Dandelion」は、タンポポに息を吹きかけると舞い上がった綿毛が地面に根付き、新しい花を咲かせるインタラクティブ作品です。デジタルによって表現が拡張されるアートなのですが、タンポポに祈りを込めて吹くという、誰もが子供の頃に遊んだピュアな原体験的感覚を呼び起こすこの作品を、僕自身とても気に入っています。' +
                    '\r\n' +
                    '\r\n' +
                    '花は言葉を必要とせず、物事を分け隔てることもしません。種子を飛ばし、たどり着いた先でまた花を咲かせます。' +
                    '\r\n' +
                    'そんな風に、国や人種、思想に関わらず誰もが知っているシンプルな行為がアートとなって人々の祈りを繋げ、世界中に花を咲かせることができればと願っています。』'
            },

            // サポーターのリンク
            //
            // logo => ロゴURL
            // url => リンク先URL
            supporters: [{
                    logo: './Images/Supporters/GB Logo SG_4C_Grey.png',
                    url: ''
                },
                {
                    logo: './Images/Supporters/sas.png',
                    url: ''
                },
                {
                    logo: './Images/Supporters/pds.png',
                    url: ''
                },
                {
                    logo: './Images/Supporters/tt.png',
                    url: ''
                },
                {
                    logo: './Images/Supporters/kddi.png',
                    url: ''
                },
                {
                    logo: './Images/Supporters/livecamera_venice.png',
                    url: ''
                },
                {
                    logo: './Images/Supporters/livecamera_tokyo.png',
                    url: ''
                },
                {
                    logo: './Images/Supporters/livecamera_capetown.png',
                    url: ''
                },
                {
                    logo: './Images/Supporters/gl.png',
                    url: ''
                }
            ],

            // フレンドのリンク
            //
            // logo => ロゴURL
            // url => リンク先URL
            friends: [{
                    logo: './Images/Friends/friends_sanomisaki.png'
                },
                {
                    logo: './Images/Friends/friends_sanomasaki.png'
                },
                {
                    logo: './Images/Friends/friends_nobu.png'
                },
                {
                    logo: './Images/Friends/friends_jun.png'
                },
                {
                    logo: './Images/Friends/friends_ryuta.png'
                },
                {
                    logo: './Images/Friends/friends_shinsaku.png'
                },
                {
                    logo: './Images/Friends/friends_reiji.png'
                },
                {
                    logo: './Images/Friends/friends_erina.png'
                },
                {
                    logo: './Images/Friends/friends_etotokiko.png'
                },
                {
                    logo: './Images/Friends/friends_fukada.png'
                },
                {
                    logo: './Images/Friends/friends_kobayashi.png'
                },
                {
                    logo: './Images/Friends/friends_kuniya.png'
                },
                {
                    logo: './Images/Friends/friends_matsuda.png'
                },
                {
                    logo: './Images/Friends/friends_etomasakazu.png'
                },
                {
                    logo: './Images/Friends/friends_etomiho.png'
                },
            ],

            // 寄付のお願い
            contribution: {
                title_pc: '『Dandelion』植樹支援（作品設置支援）のお願い',
                title_sp: '『Dandelion』植樹支援（作品設置支援）のお願い',
                message: '「DANDELION PROJECT」は、平和への祈りのシンボルとなる『Dandelion』を' +
                    '\r\n' +
                    '世界各地に”植える(展示する)”ための支援金を募集しています。' +
                    '\r\n' +
                    '人々の想いを繋ぎ、世界中に花を咲かせる活動にぜひご参加ください。' +
                    '\r\n' +
                    '\r\n',
                message_sp: '「DANDELION PROJECT」は、' +
                    '\r\n' +
                    '平和への祈りのシンボルとなる『Dandelion』を' +
                    '\r\n' +
                    '世界各地に”植える(展示する)”ための' +
                    '\r\n' +
                    '支援金を募集しています。' +
                    '\r\n' +
                    '人々の想いを繋ぎ、世界中に花を咲かせる活動に' +
                    '\r\n' +
                    'ぜひご参加ください。' +
                    '\r\n' +
                    '\r\n',
                button: '植樹チケット',
                cloudfunding_abount: '',
                cloudfunding_description: '植樹チケット以外にも、様々な形でのご支援をお待ちしております。' +
                    '\r\n' +
                    '詳細は以下までお問い合わせください。',
                cloudfunding_description_sp: '植樹チケット以外にも、' +
                    '\r\n' +
                    '様々な形でのご支援をお待ちしております。' +
                    '\r\n' +
                    '詳細は以下までお問い合わせください。',
                cloudfunding_button: '支援に関するお問い合わせ',
                cloudfunding_image: './Images/cf_logo_padded.png',
                cloudfunding_url: 'https://camp-fire.jp/projects/view/314807'
            },

            // 各種SNSのリンク
            //
            // icon => アイコン
            // url => リンク先URL
            links: [{
                    icon: './Images/icon_facebook.png',
                    url: 'https://www.facebook.com/NAKEDINC.official/'
                },
                {
                    icon: './Images/icon_instagram.png',
                    url: 'https://www.instagram.com/naked_inc/'
                }
            ],
            place: [{
                    name_mb1: '日本・廣島',
                    name_mb2: '折鶴塔',
                    image_mb: './Images/Place/mb/s00145.png',
                    name: '日本・廣島 / 折鶴塔',
                    time: '2023.5.19 ー',
                    image: './Images/Place/s00145.png',
                    tips: '一般公開・需付費入場',
                    url_msg: '',
                    url: ''
                }, {
                    name_mb1: '台湾・台北',
                    name_mb2: '松菸文創区 ',
                    image_mb: './Images/Place/mb/s00176.png',
                    name: '台湾・台北 / 松菸文創区 ',
                    time: '2026.1.31 ー 2026.6.30',
                    image: './Images/Place/s00176.png',
                    tips: '一般開放',
                    url_msg: '',
                    url: ''
                }, {
                    name_mb1: '日本・東京',
                    name_mb2: '寺田倉庫',
                    image_mb: './Images/Place/mb/s00175.png',
                    name: '日本・東京 / 寺田倉庫',
                    time: '2026.1.10 ー 2026.3.15',
                    image: './Images/Place/s00175.png',
                    tips: '一般公開・需付費入場',
                    url_msg: '詳細請點選這裡',
                    url: 'https://meets.naked.works/gaudi/'
                }, {
                    name_mb1: '日本・兵庫',
                    name_mb2: '姬路城三之丸廣場',
                    image_mb: './Images/Place/mb/s00174.png',
                    name: '日本・兵庫 / 姬路城三之丸廣場',
                    time: '2025.11.22 ー 2025.12.11',
                    image: './Images/Place/s00174.png',
                    tips: '一般公開・需付費入場',
                    url_msg: '詳細請點選這裡',
                    url: 'http://himeji-castle-dandelion.art/'
                }, {
                    name_mb1: '日本・京都',
                    name_mb2: '八坂神社',
                    image_mb: './Images/Place/mb/s00173.png',
                    name: '日本・京都 / 八坂神社',
                    time: '2025.8.8 ー 2025.8.17',
                    image: './Images/Place/s00173.png',
                    tips: '一般開放',
                    url_msg: '',
                    url: ''
                }, {
                    name_mb1: '日本・京都',
                    name_mb2: '伏見稻荷大社',
                    image_mb: './Images/Place/mb/s00172.png',
                    name: '日本・京都 / 伏見稻荷大社',
                    time: '2025.7.19 ー 2025.8.17',
                    image: './Images/Place/s00172.png',
                    tips: '一般開放',
                    url_msg: '',
                    url: ''
                }, {
                    name_mb1: '日本・兵庫',
                    name_mb2: '六甲高山植物園',
                    image_mb: './Images/Place/mb/s00171.png',
                    name: '日本・兵庫 / 六甲高山植物園',
                    time: '2025.9.20 ー 2025.12.30',
                    image: './Images/Place/s00171.png',
                    tips: '一般公開・需付費入場',
                    url_msg: '詳細請點選這裡',
                    url: 'https://rokkomeetsart.jp/'
                }, {
                    name_mb1: '日本・京都',
                    name_mb2: '元離宮二條城',
                    image_mb: './Images/Place/mb/s00170.png',
                    name: '日本・京都 / 元離宮二條城',
                    time: '2025.3.14 ー 2025.4.13',
                    image: './Images/Place/s00170.png',
                    tips: '一般公開・需付費入場',
                    url_msg: '詳細請點選這裡',
                    url: 'https://event.naked.works/nijojo/spring/ja/'
                }, {
                    name_mb1: '中國・北京',
                    name_mb2: '遇見博物館',
                    image_mb: './Images/Place/mb/s00168.png',
                    name: '中國・北京 / 遇見博物館',
                    time: '2024.11.15 ー 2025.2.16',
                    image: './Images/Place/s00168.png',
                    tips: '一般公開・需付費入場',
                    url_msg: '',
                    url: ''
                }, {
                    name_mb1: '日本・滋賀',
                    name_mb2: '日吉大社（白山姬神社）',
                    image_mb: './Images/Place/mb/s00167.png',
                    name: '日本・滋賀 / 日吉大社（白山姬神社）',
                    time: '2024.11.1 ー 2024.12.8',
                    image: './Images/Place/s00167.png',
                    tips: '一般開放',
                    url_msg: '',
                    url: ''
                }, {
                    name_mb1: '日本・石川',
                    name_mb2: '那谷寺',
                    image_mb: './Images/Place/mb/s00166.png',
                    name: '日本・石川 / 那谷寺',
                    time: '2024.10.25 ー 2024.11.24',
                    image: './Images/Place/s00166.png',
                    tips: '一般公開・需付費入場',
                    url_msg: '詳細請點選這裡',
                    url: 'https://yoru-sanpo.naked.works/natadera/'
                }, {
                    name_mb1: '日本・滋賀',
                    name_mb2: '比叡山延歷寺釋迦堂',
                    image_mb: './Images/Place/mb/s00164.png',
                    name: '日本・滋賀 / 比叡山延歷寺釋迦堂',
                    time: '2024.9.13 ー 2024.12.8',
                    image: './Images/Place/s00164.jpg',
                    tips: '一般公開・需付費入場',
                    url_msg: '',
                    url: ''
                }, {
                    name_mb1: '日本・滋賀',
                    name_mb2: '彥根城',
                    image_mb: './Images/Place/mb/s00162.png',
                    name: '日本・滋賀 / 彥根城',
                    time: '2024.3.22 ー 2024.4.9',
                    image: './Images/Place/s00162.jpg',
                    tips: '一般公開・需付費入場',
                    url_msg: '詳細請點選這裡',
                    url: 'https://www.knt.co.jp/ec/2023/hikone_night_tour/'
                },
                //  {
                //     name_mb1: '日本・大阪',
                //     name_mb2: '阿倍野 Harukas 展望台 \"Harukas 300\"',
                //     image_mb: './Images/Place/mb/s00157.png',
                //     name: '日本・大阪 / 阿倍野 Harukas 展望台 \"Harukas 300\"',
                //     time: '2023.11.28 ー 2024.3.31',
                //     image: './Images/Place/s00157.jpg',
                //     tips: '一般公開・需付費入場',
                //     url_msg: '詳細請點選這裡',
                //     url: 'https://ultraxperience.jp/0x0mugen-project/page_clf.html'
                // },
                {
                    name_mb1: '日本・大阪',
                    name_mb2: '萬博記念公園',
                    image_mb: './Images/Place/mb/s00156.png',
                    name: '日本・大阪 / 萬博記念公園',
                    time: '2023.12.1 ー 2023.12.25',
                    image: './Images/Place/s00156.jpg',
                    tips: '一般公開・需付費入場',
                    url_msg: '',
                    url: ''
                }, {
                    name_mb1: '日本・滋賀',
                    name_mb2: '彥根城',
                    image_mb: './Images/Place/mb/s00155.png',
                    name: '日本・滋賀 / 彥根城',
                    time: '2023.11.11 ー 2023.12.9',
                    image: './Images/Place/s00155.jpg',
                    tips: '一般公開・需付費入場',
                    url_msg: '詳細請點選這裡',
                    url: 'https://www.knt.co.jp/ec/2023/hikone_night_tour/'
                }, {
                    name_mb1: '日本・京都',
                    name_mb2: '元離宮二條城',
                    image_mb: './Images/Place/mb/s00144.png',
                    name: '日本・京都 / 元離宮二條城',
                    time: '2023.3.16 ー 2023.4.16',
                    image: './Images/Place/s00144.jpg',
                    tips: '一般公開・需付費入場',
                    url_msg: '詳細請點選這裡',
                    url: 'https://garden.naked.works/kyoto/'
                }, {
                    name_mb1: '日本・大阪',
                    name_mb2: 'W OSAKA',
                    image_mb: './Images/Place/mb/s00141.png',
                    name: '日本・大阪 / W OSAKA',
                    time: '2022.12.15 ー 2022.12.25',
                    image: './Images/Place/s00141.jpg',
                    tips: '一般開放',
                    url_msg: '詳細請點選這裡',
                    url: 'https://garden.naked.works/kyoto/'
                }, {
                    name_mb1: '日本・京都',
                    name_mb2: '京都國立博物館',
                    image_mb: './Images/Place/mb/s00136.png',
                    name: '日本・京都 / 京都國立博物館',
                    time: '2022.12.10 ー 2022.12.25',
                    image: './Images/Place/s00136.jpg',
                    tips: '一般公開・需付費入場',
                    url_msg: '詳細請點選這裡',
                    url: 'https://garden.naked.works/kyoto/'
                }, {
                    name_mb1: '日本・京都',
                    name_mb2: '仁和寺',
                    image_mb: './Images/Place/mb/s00135.png',
                    name: '日本・京都 / 仁和寺',
                    time: '2022.12.10 ー 2022.12.18',
                    image: './Images/Place/s00135.jpg',
                    tips: '一般公開・需付費入場',
                    url_msg: '詳細請點選這裡',
                    url: 'https://garden.naked.works/kyoto/'
                }, {
                    name_mb1: '日本・京都',
                    name_mb2: 'ACE HOTEL KYOTO',
                    image_mb: './Images/Place/mb/s00134.png',
                    name: '日本・京都 / ACE HOTEL KYOTO',
                    time: '2022.12.8 ー 2022.12.25',
                    image: './Images/Place/s00134.jpg',
                    tips: '一般開放',
                    url_msg: '詳細請點選這裡',
                    url: 'https://garden.naked.works/kyoto/'
                }, {
                    name_mb1: '日本・京都',
                    name_mb2: '西本願寺・唐門',
                    image_mb: './Images/Place/mb/s00133.png',
                    name: '日本・京都 / 西本願寺・唐門',
                    time: '2022.11.24 ー 2022.11.27',
                    image: './Images/Place/s00133.jpg',
                    tips: '一般公開・需付費入場',
                    url_msg: '詳細請點選這裡',
                    url: 'https://garden.naked.works/kyoto/'
                }, {
                    name_mb1: '日本・京都',
                    name_mb2: '平安神宮',
                    image_mb: './Images/Place/mb/s00132.png',
                    name: '日本・京都 / 平安神宮',
                    time: '2022.11.18 ー 2022.12.25',
                    image: './Images/Place/s00132.jpg',
                    tips: '一般公開・需付費入場',
                    url_msg: '詳細請點選這裡',
                    url: 'https://garden.naked.works/kyoto/'
                }, {
                    name_mb1: '日本・京都',
                    name_mb2: '北野天满宫',
                    image_mb: './Images/Place/mb/s00131.png',
                    name: '日本・京都 / 北野天满宫',
                    time: '2022.11.12 ー 2022.11.27',
                    image: './Images/Place/s00131.jpg',
                    tips: ' 一般開放・與北野天滿宮光影展一同開展',
                    url_msg: '詳細請點選這裡',
                    url: 'https://garden.naked.works/kyoto/'
                }, {
                    name_mb1: '日本・宇治',
                    name_mb2: '宇治市',
                    image_mb: './Images/Place/mb/s00130.png',
                    name: '日本・宇治 / 宇治市',
                    time: '2022.11.11 ー 2022.12.4',
                    image: './Images/Place/s00130.jpg',
                    tips: '一般公開・需付費入場',
                    url_msg: '詳細請點選這裡',
                    url: 'https://garden.naked.works/kyoto/'
                }, {
                    name_mb1: '日本・滋賀',
                    name_mb2: '彥根城',
                    image_mb: './Images/Place/mb/2022_10_dandelion_castle_fin_web.png',
                    name: '日本・滋賀 / 彥根城',
                    time: '2022.11.3 ー 2022.12.4',
                    image: './Images/Place/2022_10_dandelion_castle_fin_web.jpg',
                    tips: '一般公開・需付費入場',
                    url_msg: '',
                    url: ''
                }, {
                    name_mb1: '日本・滋賀',
                    name_mb2: '比叡山・滋賀院門跡',
                    image_mb: './Images/Place/mb/2022_10_dandelion_monseki_fin_web.png',
                    name: '日本・滋賀 / 比叡山・滋賀院門跡',
                    time: '2022.11.3 ー 2022.12.4',
                    image: './Images/Place/2022_10_dandelion_monseki_fin_web.jpg',
                    tips: '一般公開（星期五 星期六 星期天 假日）・需付費入場',
                    url_msg: '詳細請點選這裡',
                    url: 'https://garden.naked.works/kyoto/'
                }, {
                    name_mb1: '沙特阿拉伯・利雅得',
                    name_mb2: '阿爾穆拉巴',
                    image_mb: './Images/Place/mb/2022_10_dandelion_almurabaa_fin_web.png',
                    name: '沙特阿拉伯・利雅得 / 阿爾穆拉巴',
                    time: '2022.11.1 ー 2022.12.18',
                    image: './Images/Place/2022_10_dandelion_almurabaa_fin_web.jpg',
                    tips: '一般公開',
                    url_msg: '',
                    url: ''
                }, {
                    name_mb1: '日本・京都',
                    name_mb2: '元離宮二條城',
                    image_mb: './Images/Place/mb/2022_10_dandelion_nijojo_fin_web.png',
                    name: '日本・京都 / 元離宮二條城',
                    time: '2022.10.28 ー 2022.12.4',
                    image: './Images/Place/2022_10_dandelion_nijojo_fin_web.jpg',
                    tips: '一般公開・需付費入場',
                    url_msg: '詳細請點選這裡',
                    url: 'https://garden.naked.works/kyoto/'
                }, {
                    name_mb1: '日本・京都',
                    name_mb2: '上賀茂神社',
                    image_mb: './Images/Place/mb/2022_09_dandelion_kamigamoshrine_fin_web.png',
                    name: '日本・京都 / 上賀茂神社',
                    time: '2022.10.21 ー 2022.10.23',
                    image: './Images/Place/2022_09_dandelion_kamigamoshrine_fin_web.jpg',
                    tips: '一般公開',
                    url_msg: '詳細請點選這裡',
                    url: 'https://garden.naked.works/kyoto/'
                }, {
                    name_mb1: '日本・大阪',
                    name_mb2: '梅北外庭SQUARE',
                    image_mb: './Images/Place/mb/2022_09_dandelion_square_fin_web.png',
                    name: '日本・大阪 / 梅北外庭SQUARE',
                    time: '2022.10.7 ー 2022.10.9',
                    image: './Images/Place/2022_09_dandelion_square_fin_web.jpg',
                    tips: '一般公開',
                    url_msg: '詳細請點選這裡',
                    url: 'https://garden.naked.works/kyoto/'
                }, {
                    name_mb1: '日本・京都',
                    name_mb2: '舊三井老家下鴨別邸',
                    image_mb: './Images/Place/mb/2022_09_dandelion_oldmitsuifamily_fin_web.png',
                    name: '日本・京都 / 舊三井老家下鴨別邸',
                    time: '2022.9.23 ー 2022.10.2',
                    image: './Images/Place/2022_09_dandelion_oldmitsuifamily_fin_web.jpg',
                    tips: '一般公開・需付費入場',
                    url_msg: '詳細請點選這裡',
                    url: 'https://garden.naked.works/kyoto/'
                }, {
                    name_mb1: '日本・京都',
                    name_mb2: '京都市政府前',
                    image_mb: './Images/Place/mb/2022_09_dandelion_shiyakusyo_fin_web.png',
                    name: '日本・京都 / 京都市政府前',
                    time: '2022.9.15 ー 2022.9.16',
                    image: './Images/Place/2022_09_dandelion_shiyakusyo_fin_web.jpg',
                    tips: '一般開放',
                    url_msg: '詳細請點選這裡',
                    url: 'https://garden.naked.works/kyoto/'
                }, {
                    name_mb1: '日本・滋賀',
                    name_mb2: '延曆寺',
                    image_mb: './Images/Place/mb/2022_07_dandelion_hieizan_pers_fin_web.png',
                    name: '日本・滋賀 / 延曆寺',
                    time: '2022.8.4 ー 2022.8.31',
                    image: './Images/Place/2022_07_dandelion_hieizan_pers_fin_web.jpg',
                    tips: '一般公開・需付費入場',
                    url_msg: '',
                    url: ''
                }, {
                    name_mb1: '日本・京都',
                    name_mb2: '平安神宮',
                    image_mb: './Images/Place/mb/2021_09_dande_heianjingu_fin_web.png',
                    name: '日本・京都 / 平安神宮',
                    time: '2021.12.15 ー 2022.1.16',
                    image: './Images/Place/2021_09_dande_heianjingu_fin_web.jpg',
                    tips: '一般公開・需付費入場',
                    url_msg: '詳細請點選這裡',
                    url: 'https://garden.naked.works/kyoto/'
                },
                {
                    name_mb1: '日本・京都',
                    name_mb2: '嵐山',
                    image_mb: './Images/Place/mb/2021_09_dande_arashiyama_fin_web.png',
                    name: '日本・京都 / 嵐山',
                    time: '2021.12.10 ー 2021.12.19',
                    image: './Images/Place/2021_09_dande_arashiyama_fin_web.jpg',
                    tips: '一般開放',
                    url_msg: '詳細請點選這裡',
                    url: 'https://garden.naked.works/kyoto/'
                },
                {
                    name_mb1: '日本・京都',
                    name_mb2: '興聖寺',
                    image_mb: './Images/Place/mb/2021_10_dande_koushouji_fin_web.png',
                    name: '日本・京都 / 興聖寺',
                    time: '2021.12.3 ー 2021.12.5',
                    image: './Images/Place/2021_10_dande_koushouji_fin_web.jpg',
                    tips: '一般公開・需付費入場',
                    url_msg: '詳細請點選這裡',
                    url: 'https://garden.naked.works/kyoto/'
                },
                {
                    name_mb1: '日本・滋賀',
                    name_mb2: '彥根城',
                    image_mb: './Images/Place/mb/2021_11_dande_hikono_fin_web.png',
                    name: '日本・滋賀 / 彥根城',
                    time: '2021.11.27 ー 2022.1.30',
                    image: './Images/Place/2021_11_dande_hikono_fin_web.jpg',
                    tips: '一般公開・需付費入場',
                    url_msg: '',
                    url: ''
                },
                {
                    name_mb1: '日本・高知',
                    name_mb2: '高知城',
                    image_mb: './Images/Place/mb/2021_10_dande_kochijo_a4_fin_web.png',
                    name: '日本・高知 / 高知城',
                    time: '2021.11.19 ー 2022.01.10',
                    image: './Images/Place/2021_10_dande_kochijo_a4_fin_web.jpg',
                    tips: '一般公開・需付費入場',
                    url_msg: '詳細請點選這裡',
                    url: 'https://flowers.naked.works/kochi-castle/'
                },
                {
                    name_mb1: '日本・熊本',
                    name_mb2: '熊本城',
                    image_mb: './Images/Place/mb/2021_dande_kumamotojo_0928_fin_web.png',
                    name: '日本・熊本 / 熊本城',
                    time: '2021.11.19 ー 2021.12.05',
                    image: './Images/Place/2021_dande_kumamotojo_0928_fin_web.jpg',
                    tips: '一般開放',
                    url_msg: '',
                    url: ''
                },
                {
                    name_mb1: '日本・京都',
                    name_mb2: '清水寺',
                    image_mb: './Images/Place/mb/2021_10_dande_kiyomizu_1011_fin_web.png',
                    name: '日本・京都 / 清水寺',
                    time: '2021.11.17',
                    image: './Images/Place/2021_10_dande_kiyomizu_1011_fin_web.jpg',
                    tips: '不開放一般參觀',
                    url_msg: '詳細請點選這裡',
                    url: 'https://garden.naked.works/kyoto/'
                },
                {
                    name_mb1: '日本・京都',
                    name_mb2: '北野天满宫',
                    image_mb: './Images/Place/mb/2021_10_dande_kitanotenmangu3_1020_fin_web.png',
                    name: '日本・京都 / 北野天满宫',
                    time: '2021.11.13 ー 2021.11.14',
                    image: './Images/Place/2021_10_dande_kitanotenmangu3_1020_fin_web.jpg',
                    tips: '一般開放・與北野天滿宮光影展一同開展',
                    url_msg: '詳細請點選這裡',
                    url: 'https://garden.naked.works/kyoto/'
                },
                {
                    name_mb1: '法國・巴黎',
                    name_mb2: '沙瑪麗丹百貨',
                    image_mb: './Images/Place/mb/2021_10_dande_pari_1025-3_web.png',
                    name: '法國・巴黎 / 沙瑪麗丹百貨',
                    time: '2021.11.8 ー 2021.11.20',
                    image: './Images/Place/2021_10_dande_pari_1025-3_web.jpg',
                    tips: '一般開放',
                    url_msg: '',
                    url: ''
                },


                {
                    name_mb1: '日本・京都',
                    name_mb2: '仁和寺',
                    image_mb: './Images/Place/mb/2021_10_dande_ninnaji_1011_fin_web.png',
                    name: '日本・京都 / 仁和寺',
                    time: '2021.11.2',
                    image: './Images/Place/2021_10_dande_ninnaji_1011_fin_web.jpg',
                    tips: '不開放一般參觀',
                    url_msg: '詳細請點選這裡',
                    url: 'https://garden.naked.works/kyoto/'
                },
                {
                    name_mb1: '日本・京都',
                    name_mb2: '上賀茂神社',
                    image_mb: './Images/Place/mb/2021_09_dande_kamigamo_fin_web.png',
                    name: '日本・京都 / 上賀茂神社',
                    time: '2021.10.27',
                    image: './Images/Place/2021_09_dande_kamigamo_fin_web.jpg',
                    tips: '不開放一般參觀',
                    url_msg: '詳細請點選這裡',
                    url: 'https://garden.naked.works/kyoto/'
                },
                {
                    name_mb1: '日本・東京',
                    name_mb2: 'TBS',
                    image_mb: './Images/Place/mb/2021_10_dande_TVasa_0907-2_fin_web.png',
                    name: '日本・東京 / TBS',
                    time: '2021.10.1 ー 2021.10.31',
                    image: './Images/Place/2021_10_dande_TVasa_0907-2_fin_web.jpg',
                    tips: '一般開放',
                    url_msg: '',
                    url: ''


                },
                {
                    name_mb1: '日本・佐賀',
                    name_mb2: '佐賀縣廳展望台',
                    image_mb: './Images/Place/mb/2021_10_damde_saga_fin_web.png',
                    name: '日本・佐賀 / 佐賀縣廳展望台',
                    time: '2021.9.28 ー',
                    image: './Images/Place/2021_10_damde_saga_fin_web.jpg',
                    tips: '一般公開・需付費入場',
                    url_msg: '詳細請點選這裡',
                    url: 'https://garden.naked.works/saga/'


                },
                {
                    name_mb1: '日本・埼玉',
                    name_mb2: '嚕嚕米主題樂園',
                    image_mb: './Images/Place/mb/2020_11_dande_moomin_fin_web.png',
                    name: "日本・埼玉 / 嚕嚕米主題樂園",
                    time: "2020.11.21 ー 2021.03.07",
                    image: "./Images/Place/2020_11_dande_moomin_fin_web.jpg",
                    tips: '',
                    url_msg: '',
                    url: ''
                },
                {
                    name_mb1: '日本・東京',
                    name_mb2: '涉谷區立宮下公園',
                    image_mb: './Images/Place/mb/2020_09_dande_miyashita_fin_web.png',
                    name: "日本・東京 / 涉谷區立宮下公園",
                    time: "2020.11.09 ー 2020.11.15",
                    image: "./Images/Place/2020_09_dande_miyashita_fin_web.jpg",
                    tips: '',
                    url_msg: '',
                    url: ''
                },
                {
                    name_mb1: '新加坡',
                    name_mb2: '濱海灣花園',
                    image_mb: './Images/Place/mb/2020_09_dande_singapore_fin_web.png',
                    name: "新加坡 / 濱海灣花園",
                    time: "2020.11.09 ー 2020.11.15",
                    image: "./Images/Place/2020_09_dande_singapore_fin_web.jpg",
                    tips: '',
                    url_msg: '',
                    url: ''
                },
                {
                    name_mb1: '日本・東京',
                    name_mb2: '東京鐵塔',
                    image_mb: './Images/Place/mb/2021_09_dande_tokyotower_a4_fin_web.png',
                    name: "日本・東京 / 東京鐵塔",
                    time: "2020.11.09 ー",
                    image: "./Images/Place/2021_09_dande_tokyotower_a4_fin_web.jpg",
                    tips: '',
                    url_msg: '',
                    url: ''
                }
            ]
        }
    }
}